export default __webpack_public_path__ + "static/hero-4d8a711d40049de8f00bb268986902e5.mp4";